(function () {
    $(function () {
        const defaults = {
            settings: {
                // alwaysShow: true,
                onSelect: instance => {
                    // todo дефолтный обработчик
                },
                formatter: (input, date, instance) => {
                    // todo дефолтный обработчик
                },
                position: (window.innerWidth > 400) ? 'bl' : 'c',
                disableYearOverlay: true,
                startDay: 1,
                customDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            }
        }
        
        $(document).on('init-ui-datepicker', (event, userSettings) => {
            const $target = $(event.target)
            const settings = Object.assign({}, defaults.settings, userSettings)
            $target[0].picker = datepicker($target[0], settings)
        })
    })
}());
